import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export const SITE_URL = 'https://9continent.fr';
export const SITE_NAME = 'Neuvième Continent';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Balises SEO communes à toutes les pages :
 * langue française, canonical, Open Graph, Twitter Card.
 */
export default function Seo({ title, description, image = DEFAULT_IMAGE, children }) {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname === '/' ? '/' : pathname}`;
  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {children}
    </Helmet>
  );
}
